import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface DisclaimerNoteProps {
  className?: string;
  /** Optional short prefix specific to the surface, e.g. "AI-generated analysis." */
  prefix?: string;
}

/**
 * The single short line that replaces the long, duplicated "educational only,
 * not financial advice" blocks scattered across the site. The full text lives
 * at /disclaimer.
 */
export const DisclaimerNote = ({ className, prefix }: DisclaimerNoteProps) => (
  <p className={cn("text-xs text-muted-foreground", className)}>
    {prefix ? `${prefix} ` : ""}General information only — not personalised financial advice.{" "}
    <Link to="/disclaimer" className="underline underline-offset-2 hover:text-foreground">
      Read the full disclaimer
    </Link>
    .
  </p>
);

export default DisclaimerNote;
